import './index.css';
import { useVirtualizer, useWindowVirtualizer } from '@tanstack/react-virtual';

const DEFAULT_ITEM_HEIGHT = 80;
const useTableVirtualizer = ({ count, isScrollContainer, tableBodyRef }) => {
    const getScrollMargin = () => {
        if (!tableBodyRef.current) {
            return 0;
        }
        if (isScrollContainer) {
            const containerElement = tableBodyRef.current.closest('[data-qa = "table-container"]');
            return tableBodyRef?.current.offsetTop + (containerElement?.offsetTop ?? 0);
        }
        return tableBodyRef.current
            ? document.documentElement.scrollTop + tableBodyRef.current.getBoundingClientRect().top
            : 0;
    };
    const virtualizerOptions = {
        count,
        estimateSize: () => DEFAULT_ITEM_HEIGHT,
        overscan: 5,
        measureElement: (element) => {
            let rowHeight = element?.getBoundingClientRect().height;
            const siblingElement = element.nextElementSibling;
            if (siblingElement && siblingElement.hasAttribute('data-magritte-table-row-panel')) {
                rowHeight += siblingElement.getBoundingClientRect().height;
            }
            return rowHeight;
        },
        scrollMargin: getScrollMargin(),
        initialRect: { width: 0, height: 5 * DEFAULT_ITEM_HEIGHT },
    };
    const virtualizerHook = (isScrollContainer ? useVirtualizer : useWindowVirtualizer);
    const virtualizer = virtualizerHook({
        ...virtualizerOptions,
        ...(isScrollContainer
            ? {
                getScrollElement: () => {
                    return tableBodyRef.current?.closest('[data-magritte-table-wrapper]') || null;
                },
            }
            : {}),
    });
    return virtualizer;
};

export { useTableVirtualizer };
//# sourceMappingURL=useTableVirtualizer.js.map
